module.exports = __webpack_public_path__ + "img/google-logo.3e26049d.png";